module.exports = __webpack_public_path__ + "img/LLAMO.1d8d1a0c.png";